import { render } from "./ReportPage3.vue?vue&type=template&id=15e8e15d&ts=true"
import script from "./ReportPage3.vue?vue&type=script&lang=ts"
export * from "./ReportPage3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__